var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttractions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5383 6.25319H8.73583V2.05319C8.73583 1.07319 8.20499 0.874859 7.55749 1.60986L7.09083 2.14069L3.14166 6.63236C2.59916 7.24486 2.82666 7.74652 3.64333 7.74652H5.44583V11.9465C5.44583 12.9265 5.97666 13.1249 6.62416 12.3899L7.09083 11.859L11.04 7.36736C11.5825 6.75486 11.355 6.25319 10.5383 6.25319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttractions);
export default __webpack_public_path__ + "static/media/attractions.b1d2b5b181f06e3c8ad31bff52789b24.svg";
export { ForwardRef as ReactComponent };